/* eslint-disable jsx-a11y/control-has-associated-label */
import PropTypes from 'prop-types';
import React from 'react';
import CurrencyInput from 'react-currency-input';
import Dropzone from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { selecionarArquivo } from '../../app/slices/arquivosSlice';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { abrirModalArquivo } from '../../app/slices/modalSlice';
import AudioPng from '../../assets/icons/audio.png';
import PdfPng from '../../assets/icons/pdf.png';
import ZipPng from '../../assets/icons/zip.png';
import RarPng from '../../assets/icons/rar.png';
import ExcelPng from '../../assets/icons/excel.png';
import VideoPng from '../../assets/icons/video.png';
import LikePng from '../../assets/icons/like-2.png';
import UnlikePng from '../../assets/icons/unlike-2.png';
import { ReactComponent as MostraSenhaSvg } from '../../assets/icons/show.svg';
import { ReactComponent as OcultaSenhaSvg } from '../../assets/icons/hide.svg';
import {
  AreaForm,
  AreaFormTotem,
  CampoForm, CampoFormTotem, CampoFormTotemLogin, Divisor, Grid, GridArquivos, Linha, SelectForm, SelectFormTotem, SelectFormTotemBairros,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import { corReversa } from '../../util/color';
import { and, date } from '../../util/mascaras';
import Botao from '../Botao/Botao';
import GridBotao from '../GridBotao/GridBotao';
import {
  ArquivoForm,
  ColunaForm, ContainerMoney, Label, LinhaFormGap, Pergunta, Requerido, LinhaFormGapTotem, PerguntaTotem, PerguntaTotemLogin, LabelFiltro, InputFiltro, ContainerSenhaSvg,
  RadioForm,
  LabelRadioForm,
  InputRadioForm,
} from './FormControlEstilo';

const FormControl = ({
  type, label, required,
  tamanhoFlex, maxLength, idCampo, placeholder, value,
  onChange, onKeyDown, options, valueRadio, valueRadio2, valueRadio3,
  valueRadio4, idRadio, idRadio2, idRadio3, idRadio4, nameRadio,
  labelRadio, labelRadio2, labelRadio3, labelRadio4,
  changeRadio, changeRadio2, changeRadio3, changeRadio4,
  checkedRadio, checkedRadio2, checkedRadio3, checkedRadio4,
  dadosSecretaria, onClick, dadosArquivos, onDrop, onDropRejected,
  idCheck, valueCheck, nameCheck, changeCheck, utilizarTituloComoValor,
  labelCheck, defaultChecked, noBlank, busca, onRemove, onBlur, checked, cor, onFocus, altura, disabled, corFundo, secretaria,
}) => {
  const dispatch = useDispatch();
  const dadosCidade = useSelector(selectCidade);
  const limiteCaracteres = Number(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.QuantidadeCaracteres);
  const limiteCaracteres2 = Number(4000);

  if (type === 'date') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? <Requerido>*</Requerido> : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <CampoForm
          id={idCampo}
          // type={type}
          value={value && date(value)}
          onChange={onChange}
          onKeyDown={onKeyDown}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      </ColunaForm>
    );
  }

  if (type === 'money') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <ContainerMoney value={value}>
          <CurrencyInput
            thousandSeparator=""
            precision={4}
            prefix="R$ "
            decimalSeparator=","
            maxLength={maxLength}
            id={idCampo}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required={required}
          />
        </ContainerMoney>
      </ColunaForm>
    );
  }

  if (type === 'list-checkbox') {
    let diasArray = value ? value.split(',').filter((v) => v !== '') : [];

    return (
      <ColunaForm style={{ marginBottom: espacamento.pequeno }}>
        {label && (
          <Linha>
            {required ? (<Requerido>*</Requerido>) : null}
            <Pergunta htmlFor={idCampo}>
              {label}
            </Pergunta>
          </Linha>
        )}

        <div style={{
          display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 15,
        }}
        >
          {options.map(({ Id, Campo }) => {
            const isChecked = diasArray.includes(Id);

            const handleToggle = () => {
              if (isChecked) {
                diasArray = diasArray.filter((d) => d !== Id);
              } else {
                diasArray = [...diasArray, Id];
              }

              onChange(diasArray.join(','));
            };

            return (
              <label key={Id} htmlFor={Id}>
                <input
                  type="checkbox"
                  id={Id}
                  value={Id}
                  checked={isChecked}
                  onChange={handleToggle}
                />
                {' '}
                {Campo}
              </label>
            );
          })}
        </div>
      </ColunaForm>
    );
  }

  if (type === 'check') {
    return (
      <label htmlFor={idCheck} style={{ marginBottom: espacamento.pequeno }}>
        <input type="checkbox" id={idCheck} value={valueCheck} name={nameCheck} onChange={changeCheck} defaultChecked={defaultChecked} />
        {' '}
        {labelCheck}
      </label>
    );
  }

  if (type === 'check2') {
    return (
      <label htmlFor={idCheck} style={{ marginBottom: espacamento.pequeno }}>
        <input type="checkbox" id={idCheck} value={valueCheck} name={nameCheck} onChange={changeCheck} checked={checked} />
        {' '}
        {labelCheck}
      </label>
    );
  }

  if (type === 'checkCadastroTotem') {
    return (
      <label htmlFor={idCheck} style={{ marginBottom: espacamento.pequeno, fontSize: '1.32em' }}>
        <input type="checkbox" id={idCheck} value={valueCheck} name={nameCheck} onChange={changeCheck} checked={checked} style={{ fontSize: '1.35em' }} />
        {' '}
        {labelCheck}
      </label>
    );
  }

  if (type === 'termos') {
    return (
      <div style={{ marginBottom: espacamento.pequeno }}>
        <b>Termos de uso</b>

        <Divisor size="ultraPequeno" />

        <ColunaForm borda style={{ backgroundColor: '#f2f2f2' }}>
          {/* {replaceTags(dadosCidade.configuracoes.TermoDeAceite)} */}
          <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TermoDeAceite }} />
        </ColunaForm>

        <Divisor size="ultraPequeno" />

        <label htmlFor={idCheck}>
          <input type="checkbox" id={idCheck} value={valueCheck} name={nameCheck} onChange={changeCheck} />
          {' '}
          {required ? (<Requerido>*</Requerido>) : null}
          {labelCheck}
        </label>
      </div>
    );
  }

  if (type === 'termosTotem') {
    return (
      <div style={{ marginBottom: espacamento.pequeno }}>
        <b style={{ fontSize: '1.32em' }}>Termos de uso</b>

        <Divisor size="ultraPequeno" />

        <ColunaForm borda style={{ backgroundColor: '#f2f2f2', fontSize: '1.20em' }}>
          {/* {replaceTags(dadosCidade.configuracoes.TermoDeAceite)} */}
          <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TermoDeAceite }} />
        </ColunaForm>

        <Divisor size="ultraPequeno" />

        <label style={{ fontSize: '1.32em' }} htmlFor={idCheck}>
          <input type="checkbox" id={idCheck} value={valueCheck} name={nameCheck} onChange={changeCheck} />
          {' '}
          {required ? (<Requerido style={{ fontSize: 30 }}>*</Requerido>) : null}
          {labelCheck}
        </label>
      </div>
    );
  }

  if (type === 'arquivo') {
    return (
      <div style={{ marginBottom: espacamento.pequeno, marginTop: espacamento.pequeno }}>
        <Dropzone
          onDrop={onDrop}
          onDropRejected={onDropRejected}
          maxSize={200000000}
          accept="image/*, application/pdf, video/*, audio/*, application/x-rar-compressed, application/zip, multipart/x-zip, .rar, .zip, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          required={required}
        >
          {({
            getRootProps, getInputProps, isDragActive, isDragReject,
          }) => (
            <>
              <ArquivoForm {...getRootProps()}>
                <input {...getInputProps()} />
                <b>
                  {required ? (<Requerido style={{ fontSize: 17, verticalAlign: 'middle' }}>*</Requerido>) : null}
                  {!isDragActive && 'Selecione os arquivos desejados.'}
                </b>
                <b>{isDragActive && !isDragReject && 'Jogue aqui seus arquivos!'}</b>
                <b>{isDragReject && 'Arquivo não suportado!'}</b>
                <b>{ }</b>
                <Label>Áudio, fotos, pdfs, planilhas, vídeos ou arquivos compactados. Até 10 (dez).</Label>
                <small>
                  <i>.aac, .jpg, .mp3, .mp4, .mov, .ogg, .pdf, .png, .rar, .xls, .xlsx, .zip</i>
                </small>
              </ArquivoForm>
            </>
          )}
        </Dropzone>

        <Divisor />

        <Grid>
          {dadosArquivos && dadosArquivos.map((arquivo) => {
            if (arquivo && arquivo.type && arquivo.type.startsWith('audio')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: arquivo.type,
                        preview: arquivo.preview,
                      }));
                    }}
                    img={AudioPng}
                    type="arquivo"
                  />
                </div>
              );
            }
            if (arquivo && arquivo.type && arquivo.type.startsWith('video')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: arquivo.type,
                        preview: arquivo.preview,
                      }));
                    }}
                    img={VideoPng}
                    type="arquivo"
                  />
                </div>

              );
            }
            if (arquivo && arquivo.name && arquivo.name.endsWith('.rar')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    img={RarPng}
                    type="arquivo"
                  />
                </div>
              );
            }
            if (arquivo && arquivo.name && arquivo.name.endsWith('.zip')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    img={ZipPng}
                    type="arquivo"
                  />
                </div>
              );
            }
            if (arquivo && arquivo.type && arquivo.type === 'application/pdf') {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    key={arquivo.path}
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: arquivo.type,
                        preview: arquivo.preview,
                      }));
                    }}
                    img={PdfPng}
                    type="arquivo"
                  />
                </div>
              );
            }
            if (arquivo && arquivo.name && (arquivo.name.endsWith('.xlsx') || arquivo.name.endsWith('.xls'))) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    img={ExcelPng}
                    type="arquivo"
                  />
                </div>
              );
            }
            return (
              <div style={{ position: 'relative' }} key={arquivo.path}>
                <Botao
                  excluir
                  onClick={() => onRemove(arquivo)}
                />
                <GridBotao
                  key={arquivo.path}
                  onClick={() => {
                    dispatch(abrirModalArquivo());
                    dispatch(selecionarArquivo({
                      type: arquivo.type,
                      preview: arquivo.preview,
                    }));
                  }}
                  img={arquivo.preview}
                  type="arquivo"
                />
              </div>
            );
          })}
        </Grid>

        {dadosArquivos.length ? (<Divisor />) : null}
      </div>
    );
  }

  if (type === 'arquivo2') {
    return (
      <div style={{ marginBlock: 15 }}>
        <Dropzone
          onDrop={onDrop}
          maxSize={200000000}
          accept="image/*, application/pdf, video/*, audio/*, application/x-rar-compressed, application/zip, multipart/x-zip, .rar, .zip"
        >
          {({
            getRootProps, getInputProps, isDragActive, isDragReject,
          }) => (
            <>
              <ArquivoForm {...getRootProps()}>
                <input {...getInputProps()} />
                <b>{!isDragActive && 'Selecione os arquivos desejados.'}</b>
                <b>{isDragActive && !isDragReject && 'Jogue aqui seus arquivos!'}</b>
                <b>{isDragReject && 'Arquivo não suportado!'}</b>
                <b>{ }</b>
                <Label>Áudio, fotos, pdfs, vídeos ou arquivos compactados. Até 10 (dez).</Label>
                <small>
                  <i>.aac, .jpg, .mp3, .mp4, .mov, .ogg, .pdf, .png, .rar, .zip</i>
                </small>
              </ArquivoForm>
            </>
          )}
        </Dropzone>

        <GridArquivos style={{ marginBlock: 15 }}>
          {dadosArquivos && dadosArquivos.map((arquivo) => {
            if (!arquivo.type) {
              return true;
            }
            if (arquivo && arquivo.type && arquivo.type.startsWith('audio')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: arquivo.type,
                        preview: arquivo.preview,
                      }));
                    }}
                    img={AudioPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                </div>
              );
            }
            if (arquivo && arquivo.type && arquivo.type.startsWith('video')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: arquivo.type,
                        preview: arquivo.preview,
                      }));
                    }}
                    img={VideoPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                </div>

              );
            }
            if (arquivo && arquivo.name && arquivo.name.endsWith('.rar')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    img={RarPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                </div>
              );
            }
            if (arquivo && arquivo.name && arquivo.name.endsWith('.zip')) {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    img={ZipPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                </div>
              );
            }
            if (arquivo && arquivo.type && arquivo.type === 'application/pdf') {
              return (
                <div style={{ position: 'relative' }} key={arquivo.path}>
                  <Botao
                    excluir
                    onClick={() => onRemove(arquivo)}
                  />
                  <GridBotao
                    key={arquivo.path}
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: arquivo.type,
                        preview: arquivo.preview,
                      }));
                    }}
                    img={PdfPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                </div>
              );
            }
            return (
              <div style={{ position: 'relative' }} key={arquivo.path}>
                <Botao
                  excluir
                  onClick={() => onRemove(arquivo)}
                />
                <GridBotao
                  key={arquivo.path}
                  onClick={() => {
                    dispatch(abrirModalArquivo());
                    dispatch(selecionarArquivo({
                      type: arquivo.type,
                      preview: arquivo.preview,
                    }));
                  }}
                  img={arquivo.preview}
                  type="arquivo"
                />
              </div>
            );
          })}
        </GridArquivos>
      </div>
    );
  }

  if (type === 'secretaria') {
    return (
      <ColunaForm style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            Secretaria:
          </Pergunta>
        </Linha>
        <ColunaForm borda style={{ backgroundColor: dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.corSecretaria }}>
          <Linha style={{ justifyContent: 'space-between', color: corReversa(dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.corSecretaria) }}>
            <b>{dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.nomeSecretaria}</b>
            <Botao
              fechar
              fill={corReversa(dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.corSecretaria)}
              onClick={onClick}
            />
          </Linha>
        </ColunaForm>
      </ColunaForm>
    );
  }

  if (type === 'secretariaServicos') {
    return (
      <ColunaForm style={{ marginBottom: 20 }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            Secretaria:
          </Pergunta>
        </Linha>
        <ColunaForm borda style={{ backgroundColor: corFundo }}>
          <Linha style={{ justifyContent: 'space-between', color: corReversa(corFundo) }}>
            <b>{secretaria}</b>
            <Botao
              fechar
              fill={corReversa(corFundo)}
              onClick={onClick}
            />
          </Linha>
        </ColunaForm>
      </ColunaForm>
    );
  }

  if (type === 'secretariaTotem') {
    return (
      <ColunaForm style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            Secretaria:
          </PerguntaTotem>
        </Linha>
        <ColunaForm borda style={{ backgroundColor: dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.corSecretaria }}>
          <Linha style={{ justifyContent: 'space-between', color: corReversa(dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.corSecretaria) }}>
            <b style={{ fontSize: '1.35em' }}>{dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.nomeSecretaria}</b>
            <Botao
              fecharTotem
              fill={corReversa(dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.corSecretaria)}
              onClick={onClick}
            />
          </Linha>
        </ColunaForm>
      </ColunaForm>
    );
  }

  if (type === 'radio') {
    return (
      <ColunaForm borda style={{ marginBottom: espacamento.pequeno }}>
        <LinhaFormGap style={{ justifyContent: 'space-between' }}>
          <Pergunta>{label}</Pergunta>
          <Linha style={{ gap: 30, justifyContent: 'flex-end' }}>
            <label htmlFor={idRadio}>
              <input type="radio" id={idRadio} value={valueRadio} name={nameRadio} onChange={changeRadio} defaultChecked={checkedRadio} />
              {' '}
              {labelRadio}
            </label>
            {' '}
            {valueRadio2 && (
              <label htmlFor={idRadio2}>
                <input type="radio" id={idRadio2} value={valueRadio2} name={nameRadio} onChange={changeRadio2} defaultChecked={checkedRadio2} />
                {' '}
                {labelRadio2}
              </label>
            )}
            {' '}
            {valueRadio3 && (
              <label htmlFor={idRadio3}>
                <input type="radio" id={idRadio3} value={valueRadio3} name={nameRadio} onChange={changeRadio3} defaultChecked={checkedRadio3} />
                {' '}
                {labelRadio3}
              </label>
            )}
            {valueRadio4 && (
              <label htmlFor={idRadio4}>
                <input type="radio" id={idRadio4} value={valueRadio4} name={nameRadio} onChange={changeRadio4} defaultChecked={checkedRadio4} />
                {' '}
                {labelRadio4}
              </label>
            )}
          </Linha>
        </LinhaFormGap>
      </ColunaForm>
    );
  }

  if (type === 'radioTotem') {
    return (
      <ColunaForm borda style={{ marginBottom: espacamento.pequeno }}>
        <LinhaFormGap style={{ justifyContent: 'space-between' }}>
          <PerguntaTotem>{label}</PerguntaTotem>
          <Linha style={{ gap: 45, justifyContent: 'flex-end', alignSelf: 'center' }}>
            <label style={{ fontSize: '1.35em', display: 'flex', gap: 6 }} htmlFor={idRadio}>
              <input type="radio" id={idRadio} value={valueRadio} name={nameRadio} onChange={changeRadio} defaultChecked={checkedRadio} style={{ height: 25, width: 25 }} />
              {' '}
              {labelRadio}
            </label>
            {' '}
            {valueRadio2 && (
              <label style={{ fontSize: '1.35em', display: 'flex', gap: 6 }} htmlFor={idRadio2}>
                <input type="radio" id={idRadio2} value={valueRadio2} name={nameRadio} onChange={changeRadio2} defaultChecked={checkedRadio2} style={{ height: 25, width: 25 }} />
                {' '}
                {labelRadio2}
              </label>
            )}
            {' '}
            {valueRadio3 && (
              <label style={{ fontSize: '1.35em', display: 'flex', gap: 6 }} htmlFor={idRadio3}>
                <input type="radio" id={idRadio3} value={valueRadio3} name={nameRadio} onChange={changeRadio3} defaultChecked={checkedRadio3} style={{ height: 25, width: 25 }} />
                {' '}
                {labelRadio3}
              </label>
            )}
            {valueRadio4 && (
              <label style={{ fontSize: '1.35em', display: 'flex', gap: 6 }} htmlFor={idRadio4}>
                <input type="radio" id={idRadio4} value={valueRadio4} name={nameRadio} onChange={changeRadio4} defaultChecked={checkedRadio4} style={{ height: 25, width: 25 }} />
                {' '}
                {labelRadio4}
              </label>
            )}
          </Linha>
        </LinhaFormGap>
      </ColunaForm>
    );
  }

  if (type === 'radioLikeUnlike') {
    return (
      <RadioForm>
        <InputRadioForm type="radio" id={idRadio} value={valueRadio} name={nameRadio} onChange={changeRadio} defaultChecked={checkedRadio} like />
        <LabelRadioForm htmlFor={idRadio} like>
          <img src={LikePng} alt={labelRadio} />
          {labelRadio}
        </LabelRadioForm>

        {valueRadio2 && (
          <>
            <InputRadioForm type="radio" id={idRadio2} value={valueRadio2} name={nameRadio} onChange={changeRadio2} />
            <LabelRadioForm htmlFor={idRadio2}>
              <img src={UnlikePng} alt={labelRadio2} />
              {labelRadio2}
            </LabelRadioForm>
          </>
        )}
      </RadioForm>
    );
  }

  if (type === 'select') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        {/* condição feita para desabilitar o uso do select */}
        {disabled
          ? (
            <SelectForm id={idCampo} value={value} onChange={onChange} required={required} disabled>
              {!noBlank && <option value="">&nbsp;</option>}
              {options && options.map(({ Id, Campo }) => (
                <option key={Id} value={utilizarTituloComoValor ? Campo : Id}>{Campo}</option>
              ))}
            </SelectForm>
          ) : (
            <SelectForm id={idCampo} value={value} onChange={onChange} required={required}>
              {!noBlank && <option value="">&nbsp;</option>}
              {options && options.map(({ Id, Campo }) => (
                <option key={Id} value={utilizarTituloComoValor ? Campo : Id}>{Campo}</option>
              ))}
            </SelectForm>
          )}
      </ColunaForm>
    );
  }

  if (type === 'selectBairrosTotem') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido style={{ fontSize: 30 }}>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        {disabled
          ? (
            <SelectFormTotemBairros id={idCampo} value={value} onChange={onChange} required={required} placeholder={placeholder} onClick={onClick} disabled>
              {/* {!noBlank && <option value="">&nbsp;</option>}
                {options && options.map(({ Id, Campo }) => (
                  <option key={Id} value={Id}>{Campo}</option>
              ))} */}
            </SelectFormTotemBairros>
          ) : (
            <SelectFormTotemBairros id={idCampo} value={value} onChange={onChange} required={required} placeholder={placeholder} onClick={onClick}>
              {/* {!noBlank && <option value="">&nbsp;</option>}
                {options && options.map(({ Id, Campo }) => (
                  <option key={Id} value={Id}>{Campo}</option>
              ))} */}
            </SelectFormTotemBairros>
          )}
      </ColunaForm>
    );
  }

  if (type === 'selectTotem') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido style={{ fontSize: 30 }}>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <SelectFormTotem id={idCampo} value={value} onChange={onChange} required={required} onClick={onClick}>
          {!noBlank && <option value="">&nbsp;</option>}
          {options && options.map(({ Id, Campo }) => (
            <option key={Id} value={Id}>{Campo}</option>
          ))}
        </SelectFormTotem>
      </ColunaForm>
    );
  }

  if (type === 'radioTotem') {
    return (
      <ColunaForm borda tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <LinhaFormGapTotem>
          {(options && options.map(({ Campo, Id }) => (
            <div>
              <label
                htmlFor={Id}
              >
                <input
                  type="radio"
                  id={Id}
                  style={{ marginRight: 7 }}
                  value={Campo}
                  name={nameRadio}
                  onChange={onChange}
                  onFocus={onFocus}
                />
                {Campo}
              </label>
            </div>
          )))}
        </LinhaFormGapTotem>
      </ColunaForm>
    );
  }

  if (type === 'selectAno') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <SelectForm id={idCampo} value={value} onChange={onChange} required={required}>
          {!noBlank && <option value="">&nbsp;</option>}
          {options && options.map(({ Id, Campo }) => (
            <option key={Id} value={Campo}>{Campo}</option>
          ))}
        </SelectForm>
      </ColunaForm>
    );
  }

  if (type === 'textarea') {
    return (
      <div style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <AreaForm
          maxLength={limiteCaracteres}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
        />
        <Linha style={{ justifyContent: 'flex-end' }}>
          <small>
            {limiteCaracteres - value.length}
            {' '}
            caracteres
          </small>
        </Linha>
      </div>
    );
  }

  if (type === 'textareaTotem') {
    return (
      <div style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <AreaFormTotem
          maxLength={limiteCaracteres}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          type="email"
        />
        <Linha style={{ justifyContent: 'flex-end' }}>
          <small style={{ fontSize: 20, marginBottom: 5 }}>
            {limiteCaracteres - value.length}
            {' '}
            caracteres
          </small>
        </Linha>
      </div>
    );
  }

  if (type === 'textareaTotemSic') {
    return (
      <div style={{ marginBottom: 10 }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <AreaFormTotem
          maxLength={limiteCaracteres}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          type="email"
        />
        <Linha style={{ justifyContent: 'flex-end' }}>
          <small style={{ fontSize: 20, marginBottom: 5 }}>
            {limiteCaracteres - value.length}
            {' '}
            caracteres
          </small>
        </Linha>
      </div>
    );
  }

  if (type === 'textarea2') {
    return (
      <div style={{ marginBottom: espacamento.pequeno, width: '100%' }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <AreaForm
          maxLength={limiteCaracteres2}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
        />
        <Linha style={{ justifyContent: 'flex-end' }}>
          <small>
            {limiteCaracteres2 - value.length}
            {' '}
            caracteres
          </small>
        </Linha>
      </div>
    );
  }

  if (type === 'cep') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <Linha>
          <CampoForm
            maxLength={maxLength}
            id={idCampo}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required={required}
          />
          {busca ? (<Botao cep onClick={onClick} />) : (null)}
        </Linha>

      </ColunaForm>
    );
  }

  if (type === 'cepTotem') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido style={{ fontSize: 30 }}>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <Linha>
          <CampoFormTotem
            maxLength={maxLength}
            id={idCampo}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required={required}
          />
          {busca ? (<Botao cep onClick={onClick} />) : (null)}
        </Linha>

      </ColunaForm>
    );
  }

  if (type === 'senha') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <CampoForm
          type="password"
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          autocomplete="current-password"
          campoSenha="S"
        />
      </ColunaForm>
    );
  }

  if (type === 'senhaTotemCadastro') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido style={{ fontSize: 30 }}>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <CampoFormTotem
          type="password"
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          autocomplete="current-password"
          campoSenha="S"
        />
      </ColunaForm>
    );
  }

  if (type === 'senhaTotem') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: '-5px' }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotemLogin htmlFor={idCampo}>
            {label}
          </PerguntaTotemLogin>
        </Linha>
        <CampoFormTotemLogin
          type="password"
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          autocomplete="current-password"
          campoSenha="S"
        />
      </ColunaForm>
    );
  }

  if (type === 'senhaTotemLogin') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: '-5px' }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <CampoFormTotem
          type="password"
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          autocomplete="off"
        />
      </ColunaForm>
    );
  }

  if (type === 'inputTotemModalEmail') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: '-5px' }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <CampoFormTotem
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
          type="email"
        />
      </ColunaForm>
    );
  }

  if (type === 'inputLoginTotem' || type === 'inputLoginTotemVisualizacao') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ width: 700, marginBottom: -5 }}>
        <Linha>
          {required ? (<Requerido style={{ fontSize: 25 }}>*</Requerido>) : null}
          <PerguntaTotemLogin htmlFor={idCampo}>
            {label}
          </PerguntaTotemLogin>
        </Linha>
        <CampoFormTotemLogin
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
          campoSenha={type}
        />
      </ColunaForm>
    );
  }

  if (type === 'inputLoginTotemEmail') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ width: 700 }}>
        <CampoFormTotemLogin
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      </ColunaForm>
    );
  }

  if (type === 'inputTotem' || type === 'inputTotemVisualizacao') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido style={{ fontSize: 30 }}>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <CampoFormTotem
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
          campoSenha={type}
        />
      </ColunaForm>
    );
  }

  if (type === 'inputTotemNumero') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <CampoFormTotem
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
          type="number"
        />
      </ColunaForm>
    );
  }

  if (type === 'inputTotemText') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <CampoFormTotem
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
          type="email"
        />
      </ColunaForm>
    );
  }

  if (type === 'inputCnpjTotem') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: '-5px' }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <PerguntaTotem htmlFor={idCampo}>
            {label}
          </PerguntaTotem>
        </Linha>
        <CampoFormTotem
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      </ColunaForm>
    );
  }

  if (type === 'loginTotem') {
    return (
      <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
        <Linha>
          {required ? (<Requerido>*</Requerido>) : null}
          <Pergunta htmlFor={idCampo}>
            {label}
          </Pergunta>
        </Linha>
        <CampoForm
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      </ColunaForm>
    );
  }

  if (type === 'botaoFiltro') {
    return (
      <div>
        <InputFiltro id={idCampo} value={value} name={nameCheck} onChange={onChange} checked={checked} type="checkbox" hidden />
        <LabelFiltro htmlFor={idCampo} onClick={onClick}>
          {labelCheck}
        </LabelFiltro>
      </div>
    );
  }

  if (type === 'exibirSenha') {
    if (value === 'senha' || value === 'senhaTotem' || value === 'senhaTotemCadastro') {
      return (
        <ContainerSenhaSvg title="Exibir senha" altura={altura} className="controle-fundo">
          <MostraSenhaSvg onClick={onClick} />
        </ContainerSenhaSvg>
      );
    }

    return (
      <ContainerSenhaSvg title="Ocultar senha" altura={altura} className="controle-fundo">
        <OcultaSenhaSvg onClick={onClick} />
      </ContainerSenhaSvg>
    );
  }

  return (
    <ColunaForm tamanhoFlex={tamanhoFlex} style={{ marginBottom: espacamento.pequeno }}>
      <Linha>
        {required ? (<Requerido>*</Requerido>) : null}
        <Pergunta htmlFor={idCampo}>
          {label}
        </Pergunta>
      </Linha>
      {disabled ? (
        <CampoForm
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          onKeyDown={onKeyDown}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
          campoSenha={type}
          disabled
        />
      ) : (
        <CampoForm
          maxLength={maxLength}
          id={idCampo}
          placeholder={placeholder}
          value={value && and(value)}
          onChange={onChange}
          onKeyDown={onKeyDown}
          required={required}
          onBlur={onBlur}
          onFocus={onFocus}
          campoSenha={type}
        />
      )}
    </ColunaForm>
  );
};

FormControl.propTypes = {
  changeRadio: PropTypes.func,
  changeRadio2: PropTypes.func,
  changeRadio3: PropTypes.func,
  changeRadio4: PropTypes.func,
  checkedRadio: PropTypes.bool,
  checkedRadio2: PropTypes.bool,
  checkedRadio3: PropTypes.bool,
  checkedRadio4: PropTypes.bool,
  dadosSecretaria: PropTypes.oneOfType([PropTypes.object]),
  dadosArquivos: PropTypes.oneOfType([PropTypes.array]),
  disabled: PropTypes.bool,
  utilizarTituloComoValor: PropTypes.bool,
  idCampo: PropTypes.string,
  idRadio: PropTypes.string,
  idRadio2: PropTypes.string,
  idRadio3: PropTypes.string,
  idRadio4: PropTypes.string,
  label: PropTypes.string,
  labelRadio: PropTypes.string,
  labelRadio2: PropTypes.string,
  labelRadio3: PropTypes.string,
  labelRadio4: PropTypes.string,
  maxLength: PropTypes.number,
  nameRadio: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.array]),
  onDrop: PropTypes.func,
  onDropRejected: PropTypes.func,
  placeholder: PropTypes.string,
  desfocar: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  resgatarArquivo: PropTypes.func,
  required: PropTypes.bool,
  tamanhoFlex: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  valueRadio: PropTypes.string,
  valueRadio2: PropTypes.string,
  valueRadio3: PropTypes.string,
  valueRadio4: PropTypes.string,
  idCheck: PropTypes.string,
  valueCheck: PropTypes.string,
  nameCheck: PropTypes.string,
  changeCheck: PropTypes.func,
  labelCheck: PropTypes.string,
  defaultChecked: PropTypes.bool,
  noBlank: PropTypes.bool,
  busca: PropTypes.bool,
  onRemove: PropTypes.func,
  cor: PropTypes.string,
  checked: PropTypes.bool,
  onFocus: PropTypes.func,
  altura: PropTypes.string,
  corFundo: PropTypes.string,
  secretaria: PropTypes.string,
};

FormControl.defaultProps = {
  changeRadio: null,
  changeRadio2: null,
  changeRadio3: null,
  changeRadio4: null,
  checkedRadio: false,
  checkedRadio2: false,
  checkedRadio3: false,
  checkedRadio4: false,
  dadosSecretaria: null,
  dadosArquivos: null,
  disabled: false,
  idCampo: '',
  idRadio: null,
  idRadio2: null,
  idRadio3: null,
  idRadio4: null,
  label: '',
  labelRadio: null,
  labelRadio2: null,
  labelRadio3: null,
  labelRadio4: null,
  maxLength: null,
  nameRadio: null,
  onClick: null,
  onChange: null,
  onKeyDown: null,
  onBlur: null,
  desfocar: null,
  onDrop: null,
  onDropRejected: null,
  options: null,
  placeholder: null,
  required: false,
  resgatarArquivo: null,
  tamanhoFlex: 1,
  type: '',
  utilizarTituloComoValor: false,
  value: '',
  valueRadio: null,
  valueRadio2: null,
  valueRadio3: null,
  valueRadio4: null,
  idCheck: null,
  valueCheck: null,
  nameCheck: null,
  changeCheck: null,
  labelCheck: null,
  defaultChecked: false,
  noBlank: false,
  busca: true,
  onRemove: null,
  checked: false,
  cor: null,
  onFocus: null,
  altura: '',
  corFundo: '',
  secretaria: '',
};

export default FormControl;
